



























import Vue, { PropOptions } from 'vue';
import { mapGetters } from 'vuex';

interface ProductInstructorsProps {
  value: PropOptions;
}

export default Vue.extend({
  name: 'ProductSalesPageInstructors',
  props: {
    value: {
      type: Object as () => ProductSalesPageInstructorsResponse,
    },
  } as ProductInstructorsProps,
  computed: {
    ...mapGetters({
      allInstructors: 'mediaLibrary/instructors',
    }),
  },
  methods: {
    handleOnInput(key: string, value: any): void {
      const emitData = {
        ...this.value,
        [key]: value,
      };
      this.$emit('input', emitData);
    },
  },
});
